var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "gift_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#gift_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M35 11.895h-6.273c.165-.457.27-.958.27-1.474C28.997 7.975 26.986 6 24.495 6a4.517 4.517 0 0 0-3.752 1.99l-.75.987-.75-1.002A4.541 4.541 0 0 0 15.49 6C13 6 10.988 7.975 10.988 10.421c0 .516.105 1.017.27 1.474H5V34h30V11.895ZM24.495 8.947c.825 0 1.5.664 1.5 1.474 0 .81-.675 1.474-1.5 1.474-.826 0-1.501-.663-1.501-1.474 0-.81.675-1.474 1.5-1.474Zm-9.005 0c.826 0 1.501.664 1.501 1.474 0 .81-.675 1.474-1.5 1.474-.826 0-1.502-.663-1.502-1.474 0-.81.676-1.474 1.501-1.474Zm16.508 22.106H7.986v-2.948h24.012v2.948Zm0-7.369H7.986v-8.842h7.624l-3.121 4.17 2.431 1.725 5.072-6.78 5.073 6.78 2.431-1.724-3.121-4.17h7.623v8.841Z"
}))));
export default SvgGift;